module.exports = __webpack_public_path__ + "static/efectivo-747aab85cbea2989061b754a00201886.jpg";